import { Owner } from '../types';

export type OwnershipStatus = 'none' | 'partial' | 'complete' | 'over';

export interface OwnershipTotal {
    total: number;
    status: OwnershipStatus;
    canAdvance: boolean;
}

export function calculateOwnershipTotal(owners: Owner[]): OwnershipTotal {
    const total = owners.reduce((sum, owner) => sum + (owner.ownershipPercent ?? 0), 0);

    let status: OwnershipStatus;
    if (total <= 0) {
        status = 'none';
    } else if (total < 100) {
        status = 'partial';
    } else if (total === 100) {
        status = 'complete';
    } else {
        status = 'over';
    }

    return { total, status, canAdvance: status === 'complete' };
}
